import { WizActionObj } from './../../../obj/navigation/wiz-action.obj';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import { WizButton } from './../../controls/button/wiz-button/wiz-button';
import { WizEvent } from '../../../events/wiz-event';
import { WizEventManager } from '../../../events/wiz-event.manager';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, Renderer2 } from "@angular/core";
/**
 * Bouton tab
 */
@Component({
  selector: 'wiz-tab-button',
  templateUrl: './wiz-tab-button.html',
  styleUrls: ['./wiz-tab-button.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush // pas de listeneur permanent
})
export class WizTabButton extends WizButton {

  public fullDesc: string = ''; // description pour le tooltip

  public get showDelete(): boolean {
    return this.getData()?.showDelete;
  }

  public get lineBackground(): string {
    const actionObj = this.getData();
    if (!!actionObj && !!actionObj.lineColor) {
      // return actionObj.lineColor;
      return 'linear-gradient(to bottom, #ffffff00 0%, #ffffff00 80%,' + actionObj.lineColor + ' 100%)';
    } else {
      return '#ffffff00';
    }
  }

  /**
   * Référence à l'objet d'action définissant les propriétés du bouton (label, style...)
   */
  @Input()
  public set actionObj(pActionObj: WizActionObj) {
    this.setData(pActionObj);

    const actionObj = this.data; // gestion du tooltip
    // if (!!actionObj && !!actionObj.moreArgs && 'description' in actionObj.moreArgs) {
    //   this.fullDesc = actionObj.moreArgs['description'];
    // } else {
      this.fullDesc = actionObj.label;
    // }

    this.cdref.markForCheck();
  }

  public get actionObj(): WizActionObj {
    return this.getData();
  }

  /** Constructor with translation engine
   * @param cdref: ChangeDetectorRef
   * @param elementRef: ref au dom (point d'entrée)
   * @param renderer : rendu
   */
  constructor(protected cdref: ChangeDetectorRef,
              public elementRef: ElementRef,
              public  renderer: Renderer2
  ) {
    super(cdref, elementRef, renderer);
    this.setSelectedClassName('selected-tab-class');
  }

  /**
   * Handler de l'icône de suppression
   * @param event clic
   */
  public onClear(event: MouseEvent) {
    // stopper l'event, pour ne pas appeler la sélection
    event.stopImmediatePropagation();
    event.preventDefault();
    const wizEvent: WizEvent = new WizEvent(WIZ_EVENT_TYPE.DELETE, this, this.data);
    WizEventManager.dispatchEvent(this.elementRef, wizEvent);
  }
}
